import { createSelector } from 'reselect';
import { RootState } from '../../../rootReducer';
import { PropConstants } from './Helpers';

export type FormDataInitial = {
  isUpdate: boolean;
  name: string;
  version: string;
  annotationStandardId: string;
  default: boolean;
  rules: any[];
};

const getMaintenanceTrigger = (state: RootState) => state.maintenanceTriggerForm.maintenanceTrigger;
const getStandard = (state: RootState) => state.maintenanceTriggerForm.standard;

export const prepareFormDataSelector = createSelector([getMaintenanceTrigger, getStandard], (maintenanceTrigger, standard) => {
  let result: FormDataInitial = {
    isUpdate: false,
    name: '',
    version: '',
    annotationStandardId: '',
    default: false,
    rules: []
  };

  if (!maintenanceTrigger || !standard) {
    return result;
  }

  result.isUpdate = true;
  result.name = maintenanceTrigger.name;
  result.version = maintenanceTrigger.version;
  result.annotationStandardId = maintenanceTrigger.annotationStandardId;
  result.default = maintenanceTrigger.default;

  result.rules = [];

  maintenanceTrigger.items.forEach((item, index) => {
    const rule = {
      [PropConstants.ID]: item.id,
      [PropConstants.FINDING_TYPE]: item.findingTypeId,
      [PropConstants.DEFECT_LOCATION]: item.defectLocation,
      [PropConstants.RESPONSE_LEVEL_ACTION]: item.responseLevelId,
      [PropConstants.RESPONSE_LEVEL_DESCRIPTION]: item.responseLevelDescription,
      comments: item.comment,
      index
    };

    const findingType = standard.findingTypes.find(x => x.id === item.findingTypeId);

    item.findingTypePropertyItems.forEach(propertyItem => {
      const property = findingType!.findingTypeTemplate!.properties.find(x => x.id === propertyItem.findingTypePropertyId)!;
      rule[property.name] = propertyItem.value;
    });

    item.thresholdItems.forEach(tresholdItem => {
      rule[tresholdItem.name] = tresholdItem.value;
    });

    result.rules.push(rule);
  });

  return result;
});
